import { render, staticRenderFns } from "./normalTable.vue?vue&type=template&id=d858c334&scoped=true&"
import script from "./normalTable.vue?vue&type=script&lang=js&"
export * from "./normalTable.vue?vue&type=script&lang=js&"
import style0 from "./normalTable.vue?vue&type=style&index=0&id=d858c334&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d858c334",
  null
  
)

export default component.exports